
<div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
    <div class="col-12 pl-2">
        <button pButton label="pdf" 
        class="p-button-outlined mb-2" icon="pi pi-plus" (click)="dopdf()"></button>
        <canvas id="cc" ></canvas>
    </div>
</div>

